<template>
  <q-page class="stretch-grid has-search no-footer">    
    <q-collapsible class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header" class="search-box">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon name="fa fa-search" color="primary" style="padding:0 5px 3px" />Class Approvals Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <div class="sl-row no-margin">
          <div class="sl-col-4"><q-input float-label="Class ID" v-model="searchFields.CLASS_ID" /></div>
          <div class="sl-col-4">
            <q-field :helper="currentAffiliateLabel">
              <q-input float-label="Affiliate" :clear-value="null" clearable @clear="onSelectAffiliate()" v-model="affiliateFilter">
                <q-autocomplete                      
                  :debounce="500"
                  float-label="Affiliate"
                  :max-results="10"
                  @search="onAffiliateAutocomplete"
                  @selected="onSelectAffiliate"
                />
              </q-input>
            </q-field>
          </div>
          <div class="sl-col-4">
            <q-datetime
                clearable
                v-model="searchFields['CLASS.CLASS_START_DATE']"
                :before="[{icon: 'calendar_today' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Class Start Date"
                popover
              /> 
          </div>
          <!-- <div class="sl-col-4">
            <q-field :helper="currentInstructorLabel">
                <q-input float-label="Instructor" :clear-value="null" clearable @clear="onSelectInstructor()" v-model="instructorFilter">
                  <q-autocomplete                      
                    :debounce="500"
                    float-label="Instructor"
                    :max-results="10"
                    @search="onInstructorAutocomplete"
                    @selected="onSelectInstructor"
                  />
                </q-input>
              </q-field>
          </div> -->
        </div>
        <div class="sl-row no-margin">
          <div class="sl-col-4">
            <q-datetime
                clearable
                v-model="searchFields['DATE_CREATED']"
                :before="[{icon: 'how_to_vote' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Approval Date"
                popover
              /> 
          </div>
          <div class="sl-col-4">
            <q-select
                clearable
                float-label="Approval Status"
                :options="classApprovalStatuses"
                v-model="searchFields['CLASS.LK_CLASS_APPROVAL_STATUS_ID']"
                @clear="search()"
              /> 
          </div>
          <div class="sl-col-4">
            <q-datetime
                clearable
                v-model="searchFields['CLASS.CLASS_END_DATE']"
                :before="[{icon: 'calendar_today' }]"
                @clear="search()"
                type="date"
                format="MM/DD/YYYY"
                float-label="Class End Date"
                popover
              />
          </div>
        </div>

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="fetchAndClear"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>
    <Grid 
      id="classApprovalsGrid"
      :expandable="true"
      class="fit"
      :module="module" 
      :data="approvalList" 
      :columns="columnOptions"
      :loadingData="loadingData"
      :filterable="filterable"
      :pagination="paginationOptions"
      :onExport="fetchClassApprovals"
      :onLaunch="select"
      :onRequest="onFetch">
      <template slot="col-item-status" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label small"
              :class="{
                  'blue' : props.value =='SUBMITTED' || props.value =='RESUBMITTED',
                  'green' :props.value =='APPROVED',
                  'red' : props.value =='REJECTED',
                  'yellow' : props.value =='EXPIRED',
                  'grey' : props.value =='NOT SUBMITTED'
              }">
                {{props.value}}
              </div>
      </template>
      <template slot="col-item-class_start_date" slot-scope="props">
        {{moment(props.value).format("MMMM Do, YYYY h:mm A")}}
      </template>
      <template slot="col-item-date_created" slot-scope="props">
        {{moment(props.value).format("MMMM Do, YYYY h:mm A")}}
      </template>
      <template slot="col-item-expand" slot-scope="props">
        <div class="sessions-table">
          <div class="sl-row table-head">
            <div class="sl-col-12">
              Approval History
            </div>
          </div>
          <div class="sl-row table-columns">
            <div class="sl-col-3">
              Date Updated
            </div>
            <div class="sl-col-2">
              Status 
            </div>
            <div class="sl-col-4">
              Notes
            </div>
          </div>
          <div class="sl-row" v-for="approval in props.props.row.HISTORY" v-bind:key="approval.INSTRUCTOR_APPROVAL_ID">
            <div class="sl-col-3">
              {{ moment(approval.DATE_CREATED).format("MMMM Do, YYYY h:mm A")}}
            </div>
            <div class="sl-col-2">
              <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label small"
              :class="{
                  'blue' : approval.LK_CLASS_APPROVAL_STATUS_ID == 1 || approval.LK_CLASS_APPROVAL_STATUS_ID == 5,
                  'grey' : approval.LK_CLASS_APPROVAL_STATUS_ID == 6,
                  'yellow' : approval.LK_CLASS_APPROVAL_STATUS_ID == 4,
                  'green' : approval.LK_CLASS_APPROVAL_STATUS_ID == 2,
                  'red' : approval.LK_CLASS_APPROVAL_STATUS_ID == 3
              }">
                {{ lookupApprovalStatus(approval.LK_CLASS_APPROVAL_STATUS_ID) }}
              </div>
            </div>
            <div class="sl-col-4">
              {{ approval.NOTES }}
            </div>
          </div>
        </div>
      </template>
    </Grid>
  </q-page>
</template>

<script>
import Grid from '../components/Shared/Grid'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { api } from 'src/plugins/axios'
import { lkKey } from 'src/utils'
const moment = require('moment')

export default {
  name: 'ClassApprovalsGrid',
  components: {
    Grid
  },
  data () {
    return {
      filterable: true,
      moment: moment,
      module: this.$route.meta.module,
      visibleColumns: null,
      instructorFilter: '',
      currentInstructorLabel: '',
      affiliateFilter: '',
      currentAffiliateLabel: ''
    }
  },
  created(){
    let vm = this
    vm.setClassAffiliateSearch()
    vm.setInstructorSearch()
  },
  computed: {
    ...mapGetters('approvals', [
      'approvalList',
      'classApprovalStatuses'
    ]),
    ...mapState('approvals', {
      loadingData: state => state.loadingData,
      searchFields: s => s.classSearchFields,
      paginationOptions: s => s.paginationOptions,
      columnOptions: s => s.columnOptions,
    })
  },
  methods: {
    ...mapActions('classes', [
      'one'
    ]),
    ...mapActions('approvals', [
      'fetchClassApprovals',
      'exportExcel',
      'instructorAutocomplete',
      'affiliateAutocomplete'
    ]),
    ...mapMutations('classes', [
      'updateAddEditClassOpenState',
      'updateModalMode',
      'updateModalLoading',
      'updateSessionInformation',
      'updateSelectedSession',
    ]),
    ...mapMutations('approvals',[
      'setInstructorSearch',
      'setClassAffiliateSearch',
      'resetClassSearchFields'
    ]),
    onFetch (options) {
      return this.fetchClassApprovals(options)
    },
    lookupApprovalStatus(approval_status_id) {
      return lkKey('LK_CLASS_APPROVAL_STATUS_ID', approval_status_id)
    },
    select (e) {
        this.one({
          id: e.CLASS_ID,
          mode: "approve",
          newClass: false
        })
    },
    search(){
      let vm = this
      vm.$root.$emit('refreshGrid:classApprovalsGrid')
    },
    fetchAndClear(){
      let vm = this
      vm.instructorFilter = ''
      vm.currentInstructorLabel = ''
      vm.affiliateFilter = ''
      vm.currentAffiliateLabel = ''
      vm.resetClassSearchFields()
      vm.search()
    },
    onSelectInstructor(selectedInstructor){
      let vm = this
      vm.setInstructorSearch(selectedInstructor)
      vm.currentInstructorLabel = selectedInstructor ? selectedInstructor.value : null
      setTimeout(function(){
        vm.search()
      },15)
    }, 
    async onInstructorAutocomplete(s, done){
      let vm = this
      let results = await this.instructorAutocomplete(s)
      vm.currentInstructorLabel = (results.length == 0 && !vm.currentInstructorLabel) ? 'No Matching Instructors' : vm.currentInstructorLabel
      done(results)
    },
    onSelectAffiliate(selectedAffiliate){
      let vm = this
      vm.setClassAffiliateSearch(selectedAffiliate)
      vm.currentAffiliateLabel = selectedAffiliate ? selectedAffiliate.value : null
      setTimeout(function(){
        vm.search()
      },15)
    }, 
    async onAffiliateAutocomplete(s, done){
      let vm = this
      let results = await this.affiliateAutocomplete(s)
      console.log(results)
      vm.currentAffiliateLabel = (results.length == 0 && !vm.currentAffiliateLabel) ? 'No Matching Affiliates' : vm.currentAffiliateLabel
      done(results)
    }
  }
}
</script>

<style lang="stylus">
  .sessions-table {
    .sl-row {
      border-bottom: 1px solid rgba(0,0,0,0.12)
      min-height: 40px;

      &:last-child {
        border-bottom: 0;
      }

      &.table-head {
        margin-bottom: 0;
        margin-top 20px

        div {
          padding-top: 5px;
          padding-bottom: 10px;
          font-weight: 600;
          font-size: 14px;
        }
      }

      &.table-columns {
        padding-top 10px
        background #e4e4e4
        div {
          padding-bottom: 10px;
        }
      }

      div {
        text-align: center;
      }

      .q-btn {
        margin-top: -10px;
        margin-bottom: 10px;
      }
    }
  }
</style>